import React from 'react';

const ContactForm = () => (

  <section id="tw-contact-us" className="tw-contact-us">
    <div className="container">
      <div className="row">
        <div className="col">
          <div className="section-heading text-center">
            <h2>
              <small>leave a message</small>
            Request a
              {' '}
              <span>Quote</span>
            </h2>
            <span className="animate-border border-ash ml-auto mr-auto tw-mt-20 tw-mb-40" />
          </div>
        </div>
        {/* Col End */}
      </div>
      {/* Row End */}
      <div className="contact-us-form">
        <form id="contact-form" onSubmit={ event => { document.getElementById('form_botcheck').value !== '' && event.preventDefault()}} name="contact-page" className="contact-form" action="//api.nirlom.com/api/send-email" method="post">
          <input type="hidden" name="to" value="wirelesswhiz1@gmail.com" />
          <input type="hidden" name="esubject" value="New message from wireless whiz" />
          <input type="hidden" name="redirect" value="/success" />
          <div className="error-container" />
          <div className="row">
            <div className="col-lg-6">
              <div className="form-group">
                <input className="form-control form-name" name="name" id="name" placeholder="Name" type="text" required />
              </div>
            </div>
            {/* Col end */}
            <div className="col-lg-6">
              <div className="form-group">
                <input className="form-control form-phone" name="phone-number" id="phone-number" placeholder="Phone Number" type="number" />
              </div>
            </div>
            <div className="col-lg-6">
              <div className="form-group">
                <input className="form-control form-email" name="email-address" id="email-address" placeholder="Email Address" type="email" required />
              </div>
            </div>
            <div className="col-lg-6">
              <div className="form-group">
                <input className="form-control form-subject" placeholder="Phone Model" name="phone-model" id="phone-model" type="text" />
              </div>
            </div>
            <div className="col-lg-12">
              <div className="form-group">
                <textarea className="form-control form-message required-field" id="issue" name="issue" placeholder="Issue With Your Device" rows={5} defaultValue="" />
              </div>
            </div>
            {/* Col 12 end */}
          </div>
          {/* Form row end */}
          <div className="text-center">
            <input id="form_botcheck" name="form_botcheck" className="form-control" type="text" style={{ "display":"none" }} />
            <button className="btn btn-primary tw-mt-30" type="submit">Submit</button>

          </div>
        </form>
        {/* Form end */}
      </div>
      {/* Contact us form end */}
    </div>
    {/* Container End */}
  </section>

);

export default ContactForm;
